import {
  Component,
  ElementRef,
  HostListener,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SwitcherService } from 'src/app/shared/services/switcher.service';
import * as switcher from '../../../shared/componets/switcher/switcher';
import Swiper from 'swiper';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent {
  panels = [
    'Where can I subscribe to your newsletter?',
    'Where can in edit my address?',
    ' What are your opening hours?',
    ' Do I have the right to return an item?',
    ' General Terms & Conditions (GTC)',
    'Do I need to create an account to make an order?',
  ];
  panels1 = [
    'General Terms & Conditions (GTC)',
    ' Do I need to create an account to make an order??',
    ' Where can I subscribe to your newsletter?',
    ' Where can in edit my address?',
    ' What are your opening hours?',
    ' Do I have the right to return an item?',
  ];

  layoutSub: Subscription;
  isOpen: any;

  constructor(
    public renderer: Renderer2,
    public SwitcherService: SwitcherService,
    private el: ElementRef,
    private elementRef: ElementRef
  ) {
    const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;
    this.renderer.setAttribute(htmlElement, 'data-nav-layout', 'horizontal');
    this.renderer.setAttribute(htmlElement, 'data-nav-style', 'menu-click');
    this.renderer.setAttribute(htmlElement, 'data-menu-position', 'fixed');
    this.renderer.setAttribute(htmlElement, 'data-theme-mode', 'light');
    this.renderer.removeAttribute(htmlElement, 'data-header-styles');
    this.renderer.removeAttribute(htmlElement, 'data-menu-styles');
    this.renderer.removeAttribute(htmlElement, 'dir');
    this.renderer.removeAttribute(htmlElement, 'loader');
 
    this.layoutSub = SwitcherService.changeEmitted.subscribe((value) => {
      //click to open switcher
      if (value) {
        this.isOpen = document.querySelector('.switcher');
        this.isOpen.classList.value.includes('show');
        if (this.isOpen == !this.isOpen) {
          this.renderer.removeClass(this.switcher.nativeElement, 'show');
        } else {
          this.renderer.addClass(this.switcher.nativeElement, 'show');
        }
      } else {
        this.renderer.removeClass(
          this.switcher.nativeElement.firstElementChild,
          'show'
        );
        this.renderer.setStyle(
          this.switcher.nativeElement.firstElementChild,
          'show',
          '-270px'
        );
        value = false;
      }
    });
  }

   ngOnInit(): void {

     switcher.localStorageBackUp();
     const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;
     this.renderer.setAttribute(htmlElement, 'data-nav-style', 'menu-click');
     
    if (localStorage.getItem('valexHeader') == 'dark') {
      document.querySelector('html')?.setAttribute('data-theme-mode', 'dark');
    } else if (localStorage.getItem('valexHeader') == 'light') {
      document.querySelector('html')?.setAttribute('data-theme-mode', 'light');
    }

    // this.renderer.removeAttribute(htmlElement, 'style');
    this.renderer.setAttribute(htmlElement, 'data-theme-mode', 'light');
   }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  scrolled: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 10;
    const sections = this.el.nativeElement.querySelectorAll('.side-menu__item');
    const scrollPos =
      window.scrollY ||
      this.elementRef.nativeElement.ownerDocument.documentElement.scrollTop ||
      document.body.scrollTop;
    sections.forEach((el: any, i: string | number) => {
      const currLink = sections[i];
      const val: any = currLink.getAttribute('value');
      const refElement: any = this.el.nativeElement.querySelector('#' + val);

      if (refElement !== null) {
        const scrollTopMinus = scrollPos + 73;
        if (
          refElement.offsetTop <= scrollTopMinus &&
          refElement.offsetTop + refElement.offsetHeight > scrollTopMinus
        ) {
          const activeNav =
            this.el.nativeElement.querySelector('.nav-scroll.active');
          if (activeNav) {
            this.renderer.removeClass(activeNav, 'active');
          }
          this.renderer.addClass(currLink, 'active');
        } else {
          this.renderer.removeClass(currLink, 'active');
        }
      }
    });
  }

  isDataToggled = false;

  expande = false;
  expande1 = false;
  expande2 = false;

  @ViewChild('dropmenu', { static: true }) dropmenu!: ElementRef;

  toggleExpand(): void {
    this.expande = !this.expande;
    if (localStorage.getItem('data-menu-styles') == 'light') {
      document.querySelector('html')?.setAttribute('data-menu-styles', 'light');
    } else if (localStorage.getItem('data-menu-styles') == 'light') {
      document.querySelector('html')?.setAttribute('data-menu-styles', 'light');
    }
  }

  bodyclick() {
    this.expande1 = false;
    this.expande2 = false;
    this.expande = false;
    const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;
    this.renderer.setAttribute(htmlElement, 'data-toggled', 'close');

    this.renderer.removeClass(this.switcher.nativeElement, 'show');
  }

  toggleSwitcher() {
    this.SwitcherService.emitChange(true);
  }

  @ViewChild('switcher', { static: false }) switcher!: ElementRef;

  onClose() {
    this.renderer.removeClass(this.switcher.nativeElement, 'show');
  }

  body = document.querySelector('body');

 // Theme color Mode
 themeChange(type: string, type1: string) {
  const htmlElement =
    this.elementRef.nativeElement.ownerDocument.documentElement;
  this.renderer.setAttribute(htmlElement, 'data-header-styles', type1);
  localStorage.setItem('valexHeader', type1);
  this.renderer.setAttribute(htmlElement, 'data-menu-styles', type1);
  localStorage.setItem('valexMenu', type1);
  this.renderer.setAttribute(htmlElement, 'data-theme-mode', type1);
  localStorage.setItem('valexdarktheme', type1);

  // if (localStorage.getItem('valexHeader') == 'light') {
  //   this.elementRef.nativeElement.ownerDocument.documentElement?.removeAttribute(
  //     'style'
  //   );
  // }
  
  // if (localStorage.getItem('valexdarktheme') == 'light') {
  //   this.elementRef.nativeElement.ownerDocument.documentElement?.removeAttribute(
  //     'style'
  //   );
  //   localStorage.removeItem('bodyBgRGB')
  //   localStorage.removeItem('bodylightRGB')
  // }
  // this.primary(type)
  
}

  //  Directions
  DirectionsChange(type: string) {
    const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;
    this.renderer.setAttribute(htmlElement, 'dir', type);
    localStorage.setItem('dir', type);
     if (localStorage.getItem('dir') == 'ltr') {
      localStorage.removeItem('dir');
    }
    if (localStorage.getItem('dir') == 'rtl') {
      this.renderer.setAttribute(htmlElement, 'dir', type);
    }
  }

 //Theme Primary
 primary(type: string) {
  this.elementRef.nativeElement.ownerDocument.documentElement?.style.setProperty(
    '--primary-rgb',
    type
  );
 
  localStorage.setItem('primaryRGB', type);
  localStorage.setItem('valexlight-primary-color',type);
}

  //swiper
  @ViewChild('swiperContainer') swiperContainer!: ElementRef;

  ngAfterViewInit() {
    const swiperEl = this.swiperContainer.nativeElement;
    const mySwiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });
  }

  //reset switcher

  reset() {
    localStorage.clear();
    const html: any =
      this.elementRef.nativeElement.ownerDocument.documentElement;
    const body: any = document.querySelector('body');
    html.style = '';
    html.setAttribute('class', 'light');
    html.setAttribute('dir', 'ltr');
    html.setAttribute('data-header-styles', 'light');
    html.setAttribute('data-menu-styles', 'light');
    html.removeAttribute('data-theme-mode', 'light');
    html.setAttribute('data-nav-style', 'menu-click');
    body.removeAttribute('class');
    // html.removeAttribute('data-nav-style');
    // document.querySelector('#style')?.setAttribute('href', 'src/assets/scss/bootstrap.scss');
    const lightclickchecked = document.getElementById(
      'switcher-light-theme'
    ) as HTMLInputElement;
    if (lightclickchecked) {
      lightclickchecked.checked = true;
    }
    const ltrclickchecked = document.getElementById(
      'myonoffswitch54'
    ) as HTMLInputElement;
    if (ltrclickchecked) {
      ltrclickchecked.checked = true;
    }
  }

  ngOnDestroy(): void {
    const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;
    this.renderer.setAttribute(htmlElement, 'data-nav-layout', 'vertical');
    this.renderer.removeAttribute(htmlElement, 'data-nav-style', 'menu-click');
    this.renderer.removeAttribute(htmlElement, 'data-menu-position', 'fixed');

    // this.renderer.removeAttribute(htmlElement, 'style');
    // this.renderer.removeAttribute(htmlElement, 'data-theme-mode', 'light');
  }

  public localdata = localStorage;

  toggleSidebar() {
    const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;
    const currentToggleValue = htmlElement.getAttribute('data-toggled');

    if (currentToggleValue !== 'open') {
      this.renderer.setAttribute(htmlElement, 'data-toggled', 'open');
    } else {
      this.renderer.setAttribute(htmlElement, 'data-toggled', 'close');
    }
  }
}
